import React from "react";
import Container from "../../style/container";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  notification,
  Row,
} from "antd";
import AuthWrap from "../../style/auth-wrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthLayout from "../../layouts/auth.layout";
import { openError, openSuccess } from "../../utils/helper/message";
import useLogin from "../../hooks/useLogin";

const { Item, useForm } = Form;

const LoginPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect");
  const [form] = useForm();
  const [api, contextHolder] = notification.useNotification();

  const { login, loading } = useLogin();

  const onFinish = (values) => {
    login(
      values,
      (user) => {
        openSuccess(api, "Login successful");
        form.resetFields();
        navigate(redirect ? redirect : "/landlord/dashboard/");
      },
      (err) => {
        openError(api, err.message || "Login failed");
      }
    );
  };

  return (
    <Container>
      <Row style={{ justifyContent: "center", alignItems: "center" }}>
        <Col lg={{ span: 8 }} span={AuthLayout}></Col>
        <Col lg={{ span: 8 }} span={AuthLayout}>
          <AuthWrap>
            {contextHolder}
            <Form layout="vertical" form={form} onFinish={onFinish}>
              <Item>
                <h2>Sign In</h2>
              </Item>
              <Item
                name="email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "Email is required, and should be an email",
                  },
                ]}
              >
                <Input size="large" placeholder="Email" />
              </Item>
              <Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Enter Password",
                  },
                ]}
              >
                <Input.Password size="large" placeholder="Password" />
              </Item>
              <Item>
                <Checkbox>Remember me</Checkbox>
              </Item>
              <Item shouldUpdate>
                {() => (
                  <Button
                    type="primary"
                    block
                    htmlType="submit"
                    loading={loading}
                    size="large"
                    disabled={
                      !form.isFieldsTouched(true) ||
                      !!form
                        .getFieldsError()
                        .filter(({ errors }) => errors.length).length
                    }
                  >
                    Sign In
                  </Button>
                )}
              </Item>
              <Divider>Don&apos;t you have an account?</Divider>
              <Button
                type="link"
                block
                size="large"
                onClick={() => {
                  navigate(
                    redirect ? `/signup/?redirect=${redirect}` : "/signup"
                  );
                }}
              >
                Register
              </Button>
            </Form>
          </AuthWrap>
        </Col>
        <Col lg={{ span: 8 }} span={AuthLayout}></Col>
      </Row>
    </Container>
  );
};

export default LoginPage;
